module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAB4AAAAAMCAYAAACDd6DrAAAAz0lEQVR4nO3ZsQnCUBhG0c8QxULIEBau41gOY20dcIeMkF6sBCXyxvgf56xwy7vblsc1yT4AAAAAAAAAVDUkWccktySnJJuUAAAAAAAAACW1ATy3AXzRDwAAAAAAAKC8c7vAbx0BAAAAAAAAynsNGgIAAAAAAAD0wQAGAAAAAAAA6IQBDAAAAAAAANAJAxgAAAAAAACgEwYwAAAAAAAAQCfaAD6KCQAAAAAAAFDeoQ3gr44AAAAAAAAA5f3GJPckU5KPngAAAAAAAAAlTUmefw+SDPbJaV2XAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/toupiao/ckline.png
// module id = vjgS
// module chunks = 0